import $ from 'zepto';
import { onDocumentReady } from '../../main';

import { getTarget } from '../../utils';
import { modalOpenerSelector } from '../../utils/constants/classes';
import Modal from './Modal';

function initModal($trigger, $target) {
  const modal = new Modal($trigger, $target);

  $trigger.click(modal.onOpen);
  return modal;
}

export function initModals() {
  $(modalOpenerSelector).each((index, item) => {
    const $item = $(item);
    const $target = getTarget($item);
    initModal($item, $target);
  });
}

onDocumentReady('Modals', () => {
  initModals();
});

export default {
  initModals,
};
